import type { AncFormField, AncFormTemplate } from '@type/antenatal.type'

export const DEFAULT_ANC_FIELDS: AncFormField[] = [
  { key: 'blood_pressure', label: 'Blood pressure', type: 'text', required: true, unit: 'mmHg', section: 'Maternal' },
  { key: 'weight_kg', label: 'Weight', type: 'number', required: true, unit: 'kg', section: 'Maternal' },
  {
    key: 'urine_protein',
    label: 'Urine protein',
    type: 'select',
    options: ['Negative', 'Trace', '+', '++', '+++'],
    section: 'Maternal'
  },
  {
    key: 'urine_glucose',
    label: 'Urine glucose',
    type: 'select',
    options: ['Negative', 'Trace', '+', '++', '+++'],
    section: 'Maternal'
  },
  { key: 'fundal_height_cm', label: 'Fundal height', type: 'number', unit: 'cm', section: 'Fetal' },
  { key: 'fetal_heart_rate', label: 'Fetal heart rate', type: 'number', unit: 'bpm', section: 'Fetal' },
  {
    key: 'fetal_lie',
    label: 'Lie',
    type: 'select',
    options: ['Longitudinal', 'Oblique', 'Transverse', 'Not assessed'],
    section: 'Fetal'
  },
  {
    key: 'presentation',
    label: 'Presentation',
    type: 'select',
    options: ['Cephalic', 'Breech', 'Shoulder', 'Not assessed'],
    section: 'Fetal'
  },
  { key: 'tt_given', label: 'Tetanus toxoid given', type: 'boolean', section: 'Interventions' },
  { key: 'ipt_given', label: 'IPT (malaria) given', type: 'boolean', section: 'Interventions' },
  { key: 'iron_folate_given', label: 'Iron / folate given', type: 'boolean', section: 'Interventions' },
  {
    key: 'hiv_status',
    label: 'HIV status',
    type: 'select',
    options: ['Not done', 'Negative', 'Positive', 'Known positive'],
    section: 'Interventions'
  },
  {
    key: 'syphilis_status',
    label: 'Syphilis status',
    type: 'select',
    options: ['Not done', 'Negative', 'Positive'],
    section: 'Interventions'
  },
  { key: 'counseling_notes', label: 'Counseling / plan', type: 'textarea', section: 'Plan' },
  { key: 'next_appointment', label: 'Next appointment', type: 'date', required: true, section: 'Plan' }
]

export const defaultFormTemplate = (): AncFormTemplate => {
  const now = new Date().toISOString()
  return {
    id: 'tmpl-default-public',
    type: 'anc_form_template',
    attributes: {
      name: 'Standard public ANC card',
      schedule_preset: 'who_8',
      is_default: true,
      fields: DEFAULT_ANC_FIELDS,
      created_at: now,
      updated_at: now
    }
  }
}
